<template>

    <layout :brand="brand">

    <main v-if="brand.subbrands.length" class="page auth login mt-6 mb-16">

        <div class="px-10 py-16 bg-white shadow-card rounded-lg">

                <h1 class="flex-none font-bold text-2xl md:text-4xl leading-none mb-3 w-full text-center">Selecteer je vestiging:</h1>

                <div class="mx-auto sm:w-6/12 mt-10">
                    <a v-for="item in brand.subbrands" class="mb-8 block text-center bg-brand text-lg md:text-xl rounded-lg text-white font-semibold py-3 px-6 leading-6 cursor-pointer":href="item.url">{{item.name}}</a>
                </div>

        </div>

    </main>

    <main v-else class="page auth login mt-6 mb-16">
        <div class="px-10 py-16 bg-white shadow-card rounded-lg md:flex items-center ">
            <div class="md:w-1/2 md:pr-10 pb-10 md:pb-0">
                <h1 class="font-bold text-2xl md:text-4xl leading-none mb-3">Nieuw bij Bereikbaar.nu?</h1>
                <p class="opacity-50 md:text-lg mb-3 md:mb-5">Maak dan een account aan</p>

                <inertia-link href="/register" class="block bg-brand text-lg md:text-xl rounded-lg text-white font-semibold p-3 leading-6 w-full text-center">Aanmelden</inertia-link>
            </div>

            <hr class="md:hidden mb-4" />

            <div class="login md:w-1/2 md:pl-10">
                <h2 class="font-bold text-2xl md:text-3xl leading-none mb-3">Inloggen</h2>
                <p class="opacity-50 md:text-lg mb-3 md:mb-5">Inloggen kan alleen met je eigen Bereikbaar.nu-account.</p>

                <div v-if="Object.keys($page.errors).length" class="errors p-3 bg-danger text-white rounded-lg mb-10">
                    <span v-for="(error, index) in $page.errors" :key="`error-${index}`">
                        <span v-for="(errorMessage, errorMessageIndex) in error" :key="`error-message-${errorMessageIndex}`">{{ errorMessage }}</span>
                    </span>
                </div>

                <validation-observer v-slot="{ invalid, handleSubmit }">
                    <form @submit.prevent="handleSubmit(submitLogin)" novalidate>
                        <validation-provider v-slot="{ errors }" mode="eager" rules="email" slim>
                            <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                                <label for="email" class="block font-medium leading-6 text-black">E-mailadres</label>
                                <div class="mt-1 relative rounded-md">
                                    <input type="email" v-model="email" id="email" class="form-input border-none block w-full" required />
                                </div>

                                <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                            </div>
                        </validation-provider>

                        <validation-provider v-slot="{ errors }" mode="eager" slim>
                            <div class="input-wrapper mb-3" :class="{ 'error': errors[0] }">
                                <label for="password" class="block font-medium leading-6 text-black">Wachtwoord</label>
                                <div class="mt-1 relative rounded-md">
                                    <input type="password" v-model="password" id="password" class="form-input border-none block w-full" required />
                                </div>

                                <p v-if="errors[0]" class="message mt-1 text-danger">{{ errors[0] }}</p>
                            </div>
                        </validation-provider>

                        <button type="submit" class="bg-brand text-lg md:text-xl rounded-lg text-white font-semibold p-3 leading-6 w-full">Inloggen</button>
                    </form>
                </validation-observer>

                <a href="/password/reset" class="block opacity-75 md:text-lg text-center mt-8 underline">Wachtwoord vergeten?</a>
            </div>
        </div>
    </main>

    </layout>

</template>

<script>
import Layout from '@/layouts/Default';

export default {

    props: {
        brand: Object
    },

    data() {
        return {
            email: '',
            password: ''
        }
    },

    components: {
        Layout
    },

    methods: {
        submitLogin() {
            this.$inertia.post('/login', {
                email: this.email,
                password: this.password
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.page.auth.login {

    .login {
        @screen md {
            border-left: 1px solid #E0E0E0;
        }
    }

    form {

        .input-wrapper {
            > div {
                border: 1px solid #d2d6dc;
            }

            &.error > div {
                 border: 1px solid #EB5757;
            }
        }

        input, textarea, select, button {
            @apply outline-none shadow-none #{!important};

            &:focus, &:active {
                @apply outline-none shadow-none #{!important};
            }
        }
    }
}
</style>
